import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosServices from '../../utils/axios';

const initialState = {
    notification: null,
    loading: false,
    error: null,
    blacklistLoading: false,
    blacklistError: null,
    notificationServiceLoading: false,
    notificationServiceError: null,

    notificationDetail: {
        loading: false,
        error: null,
        data: null
    },
    notificationVehicle: {
        loading: false,
        error: null,
        data: null
    },
    notificationFiles: {
        loading: false,
        error: null,
        data: null
    },
    cancelNotificationService: {
        loading: false,
        error: null
    }
};

export const addBlackList = createAsyncThunk(
    'notification/addBlackList',
    async (blacklistData, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Notification/add-black-list`,
                blacklistData
            );

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            // API'den gelen hata mesajını çıkar (200, 500, 800 vb. tüm status kodları için)
            if (response.data?.exceptions && response.data.exceptions.length > 0) {
                const exception = response.data.exceptions[0];
                const errorMessage = exception.Message || exception.message || 'Kara listeye ekleme işlemi başarısız oldu';
 
                return rejectWithValue(errorMessage);
            }

            return rejectWithValue('Kara listeye ekleme işlemi başarısız oldu');
        } catch (error) { 
            // Axios error response kontrolü (500, 400 vb. HTTP hataları için)
            if (error.response?.data?.exceptions && error.response.data.exceptions.length > 0) {
                const exception = error.response.data.exceptions[0];
                const errorMessage = exception.Message || exception.message || 'Kara listeye ekleme işlemi başarısız oldu';
                return rejectWithValue(errorMessage);
            }
            
            // Direkt error.data kontrolü (axios interceptor'dan gelen)
            if (error.data?.exceptions && error.data.exceptions.length > 0) {
                const exception = error.data.exceptions[0];
                const errorMessage = exception.Message || exception.message || 'Kara listeye ekleme işlemi başarısız oldu';
                return rejectWithValue(errorMessage);
            }
            
            // Direkt error objesi kontrolü
            if (error.exceptions && error.exceptions.length > 0) {
                const exception = error.exceptions[0];
                const errorMessage = exception.Message || exception.message || 'Kara listeye ekleme işlemi başarısız oldu';
                return rejectWithValue(errorMessage);
            }
            
            return rejectWithValue(error.message || 'Kara listeye ekleme işlemi başarısız oldu');
        }
    }
);

export const addNotificationService = createAsyncThunk(
    'notification/addNotificationService',
    async (serviceData, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Notification/add-notification-service`,
                serviceData
            );

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            // Validasyon hatalarını kontrol et
            if (response.data?.statu === 800) {
                return rejectWithValue({
                    response: {
                        data: response.data
                    }
                });
            }

            return rejectWithValue({
                response: {
                    data: {
                        exceptions: [{
                            Message: 'Hizmet ekleme işlemi başarısız oldu'
                        }]
                    }
                }
            });
        } catch (error) {
            console.error('Add Notification Service Error:', error);
            return rejectWithValue(error);
        }
    }
);

// İhbar detayını getir
export const getNotificationDetail = createAsyncThunk(
    'supplierApp/getNotificationDetail',
    async (idNotification, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Notification/get-notification?idNotification=${idNotification}`
            );

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            return rejectWithValue(response.data?.exceptions?.[0] || 'İhbar detayı alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'İhbar detayı yüklenirken bir hata oluştu');
        }
    }
);

// Araç yükleme/indirme bilgilerini gönder
export const addNotificationVehicle = createAsyncThunk(
    'supplierApp/addNotificationVehicle',
    async (addNotificationVehicles, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/add-notification-vehicle`,
                { addNotificationVehicles }
            );

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            return rejectWithValue(response.data?.exceptions?.[0] || 'Dosya bilgileri gönderilemedi');
        } catch (error) {
            return rejectWithValue(error.message || 'İşlem sırasında bir hata oluştu');
        }
    }
);

export const getNotificationFiles = createAsyncThunk(
    'notification/getNotificationFiles',
    async (idNotificationService, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-notification-file?idNotificationService=${idNotificationService}`
            );
            if (response.data?.statu === 200) {
                return response.data.data;
            }
            return rejectWithValue(response.data?.exceptions?.[0] || 'Dosya bilgisi alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Dosya bilgisi alınamadı');
        }
    }
);

export const cancelNotificationService = createAsyncThunk(
    'notification/cancelNotificationService',
    async ({ idNotificationService, dsNote }, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Notification/change-state`,
                { idNotificationService, dsNote }
            );

            console.log('API Response:', response.data);

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            // API'den gelen hata mesajını çıkar
            if (response.data?.exceptions && response.data.exceptions.length > 0) {
                const exception = response.data.exceptions[0];
                const errorMessage = exception.Message || exception.message || 'İşlem iptal edilemedi';
                console.log('Extracted error message:', errorMessage);
                return rejectWithValue(errorMessage);
            }

            return rejectWithValue('İşlem iptal edilemedi');
        } catch (error) {
            console.error('Cancel notification service error:', error);
            console.log('Error response data:', error.response?.data);
            console.log('Error data:', error.data);
            console.log('Full error object:', error);
            
            // Axios error response kontrolü
            if (error.response?.data?.exceptions && error.response.data.exceptions.length > 0) {
                const exception = error.response.data.exceptions[0];
                const errorMessage = exception.Message || exception.message || 'İşlem iptal edilirken bir hata oluştu';
                console.log('Extracted error message from catch (response):', errorMessage);
                return rejectWithValue(errorMessage);
            }
            
            // Direkt error.data kontrolü (axios interceptor'dan gelen)
            if (error.data?.exceptions && error.data.exceptions.length > 0) {
                const exception = error.data.exceptions[0];
                const errorMessage = exception.Message || exception.message || 'İşlem iptal edilirken bir hata oluştu';
                console.log('Extracted error message from catch (data):', errorMessage);
                return rejectWithValue(errorMessage);
            }
            
            // Direkt error objesi kontrolü (console çıktısından görüldüğü gibi)
            if (error.exceptions && error.exceptions.length > 0) {
                const exception = error.exceptions[0];
                const errorMessage = exception.Message || exception.message || 'İşlem iptal edilirken bir hata oluştu';
                console.log('Extracted error message from catch (direct):', errorMessage);
                return rejectWithValue(errorMessage);
            }
            
            return rejectWithValue(error.message || 'İşlem iptal edilirken bir hata oluştu');
        }
    }
);

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        clearNotification: (state) => {
            state.notification = null;
            state.error = null;
        },
        clearNotificationDetail: (state) => {
            state.notificationDetail.data = null;
        },
        clearBlacklistError: (state) => {
            state.blacklistError = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addBlackList.pending, (state) => {
                state.blacklistLoading = true;
                state.blacklistError = null;
            })
            .addCase(addBlackList.fulfilled, (state) => {
                state.blacklistLoading = false;
            })
            .addCase(addBlackList.rejected, (state, action) => {
                state.blacklistLoading = false;
                state.blacklistError = action.payload;
            })
            .addCase(addNotificationService.pending, (state) => {
                state.notificationServiceLoading = true;
                state.notificationServiceError = null;
            })
            .addCase(addNotificationService.fulfilled, (state) => {
                state.notificationServiceLoading = false;
            })
            .addCase(addNotificationService.rejected, (state, action) => {
                state.notificationServiceLoading = false;
                state.notificationServiceError = action.payload;
            })

            // İhbar detayı
            .addCase(getNotificationDetail.pending, (state) => {
                state.notificationDetail.loading = true;
                state.notificationDetail.error = null;
            })
            .addCase(getNotificationDetail.fulfilled, (state, action) => {
                state.notificationDetail.loading = false;
                state.notificationDetail.data = action.payload;
                state.notificationDetail.error = null;
            })
            .addCase(getNotificationDetail.rejected, (state, action) => {
                state.notificationDetail.loading = false;
                state.notificationDetail.error = action.payload;
            })
            // Araç yükleme/indirme bilgileri
            .addCase(addNotificationVehicle.pending, (state) => {
                state.notificationVehicle.loading = true;
                state.notificationVehicle.error = null;
            })
            .addCase(addNotificationVehicle.fulfilled, (state, action) => {
                state.notificationVehicle.loading = false;
                state.notificationVehicle.data = action.payload;
                state.notificationVehicle.error = null;
            })
            .addCase(addNotificationVehicle.rejected, (state, action) => {
                state.notificationVehicle.loading = false;
                state.notificationVehicle.error = action.payload;
            })
            .addCase(getNotificationFiles.pending, (state) => {
                state.notificationFiles.loading = true;
                state.notificationFiles.error = null;
            })
            .addCase(getNotificationFiles.fulfilled, (state, action) => {
                state.notificationFiles.loading = false;
                state.notificationFiles.data = action.payload;
                state.notificationFiles.error = null;
            })
            .addCase(getNotificationFiles.rejected, (state, action) => {
                state.notificationFiles.loading = false;
                state.notificationFiles.error = action.payload;
                state.notificationFiles.data = null;
            })
            .addCase(cancelNotificationService.pending, (state) => {
                state.cancelNotificationService.loading = true;
                state.cancelNotificationService.error = null;
            })
            .addCase(cancelNotificationService.fulfilled, (state) => {
                state.cancelNotificationService.loading = false;
                state.cancelNotificationService.error = null;
            })
            .addCase(cancelNotificationService.rejected, (state, action) => {
                state.cancelNotificationService.loading = false;
                state.cancelNotificationService.error = action.payload;
            });
    }
});

export const { clearNotification, clearNotificationDetail, clearBlacklistError } = notificationSlice.actions;
export default notificationSlice.reducer;


